import Loading from "../components/loading";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import useCustomState from "../hooks/State";
import { UpdateNavigations } from "../store/actions";
import LiveDevice from "../components/LiveDevice/LiveDevice";
import Call from "../service/API";

const LiveDeviceView = (props) => {
  const deviceSerial = props.match.params.deviceSerial;
  const isLoading = useCustomState(true);
  const dispatch = useDispatch();
  const deviceInfo = useCustomState({});
  const deviceConsumption = useCustomState([]);
  const consumptionLoading = useCustomState(true);
  const consumptionPage = useCustomState(1);
  const orderTypes = useCustomState([]);
  const deviceOrderPage = useCustomState(1);
  const deviceOrders = useCustomState([]);
  const lastConsumption = useCustomState({});
  const lastDataId = useCustomState("");

  const changeTablePage = (page) => {
    consumptionPage.handleChange(page);
    consumptionLoading.handleChange(true);
    fetchDeviceConsumption(
      deviceSerial,
      deviceConsumption,
      consumptionLoading,
      page
    );
  };
  const changeOrderPage = (page) => {
    deviceOrderPage.handleChange(page);
    fetchDeviceOrders(deviceSerial, deviceOrders, page);
  };
  const updateOrdersTable = () => {
    deviceOrderPage.handleChange(1);
    fetchDeviceOrders(deviceSerial, deviceOrders, 1);
  };
  useEffect(() => {
    fetchDeviceInfo(deviceSerial, deviceInfo, isLoading, dispatch);
    fetchDeviceConsumption(
      deviceSerial,
      deviceConsumption,
      consumptionLoading,
      consumptionPage.value,
      lastDataId
    );
    fetchLastData(deviceSerial, lastConsumption);
    isLoading.handleChange(false);
    fetchOrderTypes(orderTypes);
    fetchDeviceOrders(deviceSerial, deviceOrders, deviceOrderPage.value);
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      fetchLastData(deviceSerial, lastConsumption);
    }, 30000);

    return () => clearInterval(interval);
  }, []);
  return (
    <>
      {isLoading.value ? (
        <div style={{ position: "relative", width: "100%", height: "100%" }}>
          <Loading />
        </div>
      ) : (
        <>
          <LiveDevice
            information={deviceInfo}
            changeTablePage={changeTablePage}
            records={deviceConsumption.value}
            tablePage={consumptionPage.value}
            orderTypes={orderTypes.value}
            changeOrderPage={changeOrderPage}
            deviceOrders={deviceOrders.value}
            orderPage={deviceOrderPage.value}
            updateOrder={updateOrdersTable}
            lastData={lastConsumption.value}
            lastID={lastDataId}
          />
        </>
      )}
    </>
  );
};
export default LiveDeviceView;
const fetchDeviceInfo = (deviceSerial, deviceInfo, isLoading, dispatch) => {
  const data = {
    water_meter_serial: deviceSerial,
  };
  Call("POST", "watermeters/admin/getOne", data)
    .then((response) => {
      if (response.data.code === 200) {
        deviceInfo.handleChange(response.data.data);
        isLoading.handleChange(false);
        const navigations = [
          { name: "مدیریت پروژه ها", path: "/admin/projects" },
          {
            name: "جزئیات پروژه",
            path:
              "/admin/project-dash/" +
              response.data.data.water_meter_project_info.project_id,
          },
          {
            name: "دیوایس های زنده",
            path: "/admin/live-devices/" + deviceSerial,
          },
        ];
        dispatch(UpdateNavigations(navigations));
      }
    })
    .catch((error) => {
      if (error.response) {
      }
    });
};
const fetchDeviceConsumption = (
  deviceSerial,
  consumption,
  isLoading,
  page,
  lastDataId
) => {
  const data = {
    page: page,
    count: 20,
    start_time: null,
    end_time: null,
    water_meters: deviceSerial,
    water_meter_user: null,
    water_meter_project: null,
    water_meter_type: null,
  };
  Call("POST", "watermeters/admin/getAll/consumption", data)
    .then((response) => {
      if (response.data.code === 200) {
        consumption.handleChange(response.data.data);
        if (page === 1) {
          // console.log(response.data.data[0]?.consumption_id);
          lastDataId.handleChange(response.data.data[0]?.consumption_id);
        }
        isLoading.handleChange(false);
      }
    })
    .catch((error) => {
      if (error.response) {
      }
    });
};
const fetchOrderTypes = (orderTypes) => {
  const data = {
    page: 1,
    count: 100,
  };
  Call("POST", "OrderType/admin/getAll", data)
    .then((response) => {
      if (response.data.code === 200) {
        orderTypes.handleChange(response.data.data);
      }
    })
    .catch((error) => {
      if (error.response) {
      }
    });
};
const fetchDeviceOrders = (deviceSerial, deviceOrders, orderPage) => {
  const data = {
    page: orderPage,
    count: 10,
    order_meter: deviceSerial,
    order_type_id: null,
    order_type_code: null,
  };
  Call("POST", "Order/admin/getAll", data)
    .then((response) => {
      if (response.data.code === 200) {
        deviceOrders.handleChange(response.data.data);
      }
    })
    .catch((error) => {
      if (error.response) {
      }
    });
};
const fetchLastData = (deviceSerial, lastConsumption, checkUpdates) => {
  const data = {
    water_meter_serial: deviceSerial,
  };
  Call("POST", "watermeters/admin/getLast/consumption", data)
    .then((response) => {
      if (response.data.code === 200) {
        lastConsumption.handleChange(response.data.data);
      }
    })
    .catch((error) => {
      if (error.response) {
      }
    });
};
